<template lang="pug">
#profile
  .container.custom_container_lg
    .row
      breadcrumb
    .row
      .col-12.text-center.i_mt_14.i_mt_md_10
        .desc
          p {{ companyProfile.area01_Content }}
  section.difference.container
    .row
      .col-12.text-center
        h2.title.i_mt_10 {{ companyProfile.area01_Title01 }}
      .col-md-6.text-center.i_mt_6
        .feature.i_mr_1.i_ptb_7.i_plr_10.i_ptb_md_6.i_plr_md_8.i_plr_sm_12.i_mr_sm_0
          .wrapper.d-flex.flex-md-column.align-items-center
            img(:src="companyProfile.area01_Profile01_Icon")
            h5.i_ml_3 {{ companyProfile.area01_Profile01_Title }}
          p.i_mt_3 {{ companyProfile.area01_Profile01_Content }}
      .col-md-6.text-center.i_mt_6
        .feature.i_ml_1.i_ptb_7.i_plr_10.i_ptb_md_6.i_plr_md_8.i_plr_sm_12.i_ml_sm_0
          .wrapper.d-flex.flex-md-column.align-items-center
            img(:src="companyProfile.area01_Profile02_Icon")
            h5.i_mt_4.i_ml_3 {{ companyProfile.area01_Profile02_Title }}
          p.i_mt_3 {{ companyProfile.area01_Profile02_Content }}
  .container
    .row.i_mt_12
      .col-md-12.text-center
        h2.title {{ companyProfile.area01_Title02 }}
    .row.i_mt_4.i_pb_4
      .col-6.col-sm-6.col-md-3.i_mt_8.creative(
        v-for="(newsProduct, index) in companyProfile.area01_NewProductList",
        :key="index"
      )
        h4 {{ newsProduct.Year }}
          span 年
        hr
        p(v-html="newsProduct.Content")
  .container-fluid.bg_blue
    customer(
      :image="companyProfile.area02_Image01",
      :title="companyProfile.area02_Title01",
      :locationNumber="companyProfile.area02_LocationNumber"
    )
  .container-fluid.bg_white.customer_service.i_pt_sm_10
    .row.flex-row-reverse.flex-md-row
      .col-6.d-flex.flex-column.justify-content-center.align-items-center
        .wrapper
          h2.title {{ companyProfile.area02_Title02 }}
          p(v-html="companyProfile.area02_Content02")
      .col-6
        .img(
          :style="{ backgroundImage: 'url(' + companyProfile.area02_Image02 + ')' }"
        )
    .row.d-md-none.text-center
      .col-12
        p(v-html="companyProfile.area02_Content02")
    .row.flex-row-reverse.flex-md-row
      .col-6
        .img(
          :style="{ backgroundImage: 'url(' + companyProfile.area02_Image03 + ')' }"
        )
      .col-6.d-flex.flex-column.justify-content-center.align-items-center
        .wrapper
          h2.title {{ companyProfile.area02_Title03 }}
          p(v-html="companyProfile.area02_Content03")
    .row.d-md-none.text-center
      .col-12
        p(v-html="companyProfile.area02_Content03")
  section.container-fluid.best_service.img(
    :style="{ backgroundImage: 'url(' + companyProfile.area03_Background + ')' }"
  )
    .container.i_ptb_8
      .row
        .col-12.text-center
          h2.title {{ companyProfile.area03_Title01 }}
      .row.i_mt_6
        .col-12
          .sign_container.flex_h.justify-content-around.justify-content-lg-between
            sign(
              v-for="(service, index) in bestService",
              :key="index",
              :title="service.title",
              :engTitle="service.engTitle"
            )
        .col-12.i_mt_6
          p.sign_text {{ companyProfile.area03_SubTitle01 }}
  section.container-fluid.bg_white.services
    .container.i_ptb_8
      .row
        .col-12.text-center
          h2.title {{ companyProfile.area03_Title02 }}
          h5.d-md-none 不斷優化與創新的服務，全方位滿足客戶的需求
      .row.i_mt_6.d-none.d-md-flex
        .col-4.align-items-center(
          v-for="(service, index) in companyProfile.area03_ServiceList",
          :key="index"
        )
          three-grid-item.i_mt_7(
            :title="service.Title",
            :subtitle="service.SubTitle",
            :img="service.Icon"
          )
      .row.i_mt_6.d-md-none.mobile
        .col-12.i_p_0
          swiper.swiper-container(:options="swiperOption", ref="mySwiper")
            swiper-slide.swiper-slide.d-flex.flex-column.align-items-center(
              v-for="(service, index) in companyProfile.area03_ServiceList",
              :key="index"
            )
              three-grid-item(
                :title="service.Title",
                :subtitle="service.SubTitle",
                :img="service.Icon"
              )
          svg-icon.swiper-prev.d-md-none(
            iconClass="arrow_left_mobile",
            className="icon",
            @click="prevClick"
          )
          svg-icon.swiper-next.d-md-none(
            iconClass="arrow_right_mobile",
            className="icon",
            @click="nextClick"
          )
      .row.i_mt_8
        .see_more_btn.sm.btn_yellow(@click="toDifferent") 看更多
  ad-video(
    :title="companyProfile.area04_Title",
    :content="companyProfile.area04_SubTitle",
    :videoID="companyProfile.area04_YoutubeID",
    :watchUrl="companyProfile.area04_URL"
  )
  .container.i_ptb_12
    .row
      .col-12.text-center
        h2.title {{ companyProfile.area05_Title }}
    .row
      .col-12
        resource(
          v-for="(resource, index) in resources",
          :key="index",
          :resource="resource"
        )
  section.summary.container
    .row
      .col-md-6.text-center.i_mt_6
        .feature.i_mr_1.i_ptb_7.i_plr_10.i_ptb_md_6.i_plr_md_8.i_plr_sm_12.i_mr_sm_0
          .wrapper.d-flex.align-items-center.justify-content-center
            img(:src="companyProfile.area06_Icon01")
            h5.i_ml_5.i_ml_md_3.i_ml_sm_5 {{ companyProfile.area06_Title01 }}
          p.i_mt_6(v-html="companyProfile.area06_Content01")
      .col-md-6.text-center.i_mt_6
        .feature.i_ml_1.i_ptb_7.i_plr_10.i_ptb_md_6.i_plr_md_8.i_plr_sm_12.i_ml_sm_0
          .wrapper.d-flex.align-items-center.justify-content-center
            img(:src="companyProfile.area06_Icon02")
            h5.i_ml_5.i_ml_md_3.i_ml_sm_5 {{ companyProfile.area06_Title02 }}
          .year_wrapper.d-flex.i_mt_6
            p.title.flex-grow-1.flex-shrink-0 {{ companyProfile.area06_Honor_Year01 }}
            .i_ml_4
              h6.title.text-left {{ companyProfile.area06_Honor_Title01 }}
              p {{ companyProfile.area06_Honor_Content01 }}
          .year_wrapper.d-flex.i_mt_3
            p.title.flex-grow-1.flex-shrink-0 {{ companyProfile.area06_Honor_Year02 }}
            .i_ml_4
              h6.title.text-left {{ companyProfile.area06_Honor_Title02 }}
              p {{ companyProfile.area06_Honor_Content02 }}
          router-link(:to="{ name: 'AboutUsProfileHonor' }")
            .see_more_btn.sm.btn_blue_ci.i_mt_sm_4 瞭解更多
</template>

<script>
import Sign from "@/components/about_us/Sign";
import Customer from "@/components/home/Customer";
import AdVideo from "@/components/about_us/AdVideo";
import Resource from "@/components/about_us/Resource";
import ThreeGridItem from "@/components/common/ThreeGridItem";
import { getCompanyProfile } from "@/json/about_us";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "AboutUsProfile",
  metaInfo() {
    return {
      title: this.companyProfile.SEO_Title,
      meta: [
        { name: "description", content: this.companyProfile.SEO_Description },
      ],
    };
  },
  components: {
    sign: Sign,
    customer: Customer,
    resource: Resource,
    "ad-video": AdVideo,
    "three-grid-item": ThreeGridItem,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: 3,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      companyProfile: {},
      bestService: [
        { title: "創新經營", engTitle: "Brand-new" },
        { title: "專業效率", engTitle: "Efficiency" },
        { title: "心安信賴", engTitle: "Safety" },
        { title: "永續卓越", engTitle: "Top" },
      ],
      resources: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    this.getCompanyProfile();
  },
  methods: {
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    getCompanyProfile() {
      getCompanyProfile().then((response) => {
        this.companyProfile = response.data;
        let resource1 = {
          title: this.companyProfile.area05_CompanyTitle01,
          content: this.companyProfile.area05_CompanyContent01,
          image: this.companyProfile.area05_CompanyImage01,
        };
        let resource2 = {
          title: this.companyProfile.area05_CompanyTitle02,
          content: this.companyProfile.area05_CompanyContent02,
          image: this.companyProfile.area05_CompanyImage02,
        };
        this.resources = [];
        this.resources.push(resource1);
        this.resources.push(resource2);
      });
    },
    itemClick(url) {
      window.open(url);
    },
    toDifferent() {
      this.$router.push({
        name: "DifferenceService",
        params: {
          id: this.companyProfile.area03_ServiceDetail_ID,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/about_us";
@import "@/assets/style/about_us/profile";
</style>
